// Auto-generated build version
export const VERSION = '1.0.25';
export const BUILD_TIME = '2026-08-26T21:47:14.960Z';
